<template>
  <div class="userNameList">
    <div v-if="list&&list.length">
      <div
        @click="toPage(item.code)"
        v-for="(item, ind) in list"
        :key="ind"
        class="item"
      >
        <p class="name">{{ item.name }}</p>
        <p class="code">{{ item.code }}</p>
        <p class="address">{{ item.address }}</p>
      </div>
    </div>
    <div v-if="!(list&&list.length)" class="no-data">暂无信息，请检查后查询</div>
  </div>
</template>

<script>
import { getUser, getName } from "@/api";

export default {
  data() {
    return {
      companyCode: sessionStorage.getItem("companyCode"),
      list: [],
    };
  },
  mounted() {
    let params = {
      name: this.$route.query.name,
    };
    getName(params).then((res) => {
      this.list = res.data;
    });
  },
  methods: {
    toPage(code) {
      getUser({
        code: code,
      }).then((res) => {
        if (res) {
          this.$router.push({
            path: "/customer",
            query: res.data,
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.userNameList {
  padding: 10px;
}
.item {
  padding: 10px 3%;
  background: #fff;
  border-radius: 5px;
  margin-bottom: 10px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}
.address {
  padding-top: 5px;
  margin-top: 5px;
  border-top: 1px solid #f1f1f1;
  color: dimgray;
}
.name,
.code {
  font-size: 16px;
  line-height: 30px;
  font-weight: bold;
}
.no-data {
  text-align: center;
  color: dimgray;
}
</style>



// WEBPACK FOOTER //
// src/view/yhBind/userNameList.vue